import MapIcon from "@mui/icons-material/MapOutlined";
import Box from "@mui/material/Box";
import type { SxProps, Theme } from "@mui/material/styles";
import type { FC } from "react";

const GRID_SIZE = 24;

/**
 * Stand-in for the design's map thumbnail until solutions carry a map snapshot: a light map-grid
 * tile in the design's highlight blue. Purely decorative.
 */
export const MapThumb: FC<{ sx?: SxProps<Theme> }> = ({ sx }) => (
	<Box
		aria-hidden
		sx={[
			theme => ({
				display: "grid",
				placeItems: "center",
				flexShrink: 0,
				color: "brand.highlight",
				bgcolor: "background.default",
				backgroundImage: `linear-gradient(${theme.palette.divider} 1px, transparent 1px), linear-gradient(90deg, ${theme.palette.divider} 1px, transparent 1px)`,
				backgroundSize: `${GRID_SIZE}px ${GRID_SIZE}px`
			}),
			...(Array.isArray(sx) ? sx : [sx])
		]}>
		<MapIcon />
	</Box>
);
